<template>
  <a-rate :value="star / 20" allowHalf disabled />
</template>

<script>
export default {
  props: {
    star: {
      type: [Number, String],
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped></style>
